import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import swal from 'sweetalert'
import secureLocalStorage from 'react-secure-storage'
import config, { axiosInstance } from '../Config'
import Loader from '../Loader'
import moment from 'moment'
import { toast } from 'react-toastify'

const AddSlots = () => {

    const navigate = useNavigate()
    const { slot_id, dayid } = useParams()

    const [slots, setSlots] = useState([{ id: dayid, start: "", end: "", location: "", lesson_type: "" }])
    const [dayName, setDayName] = useState('')
    const [loading, setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [isDisabled, setIsDisabled] = useState(false)
    // console.log(JSON.stringify(slots)

    const credentials = secureLocalStorage.getItem('credentials')
    const [lessonTypes, setLessonTypes] = useState([])
    const slotTimerRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0)
        getDaysInfo()
        getLessonTypes()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // get existing slots
    function getDaysInfo() {
        setLoading2(true)

        setDayName(getDayName(Number(slot_id)))

        axiosInstance.get(`get-slot/${slot_id}`, {
            headers: {
                Authorization: `Bearer ${credentials.token}`
            }
        })
            .then(res => {
                // console.log('seeSlots', res.data)
                const slot_data = res.data.Slots?.map((slot, index) => {
                    // Parse the 'slot?.slots' JSON string if it's a string
                    const parsedSlots = slot?.slots ? JSON.parse(slot?.slots) : [];

                    // Map over the parsed slots and return each slot with the desired properties
                    return parsedSlots.map((parsedSlot) => ({
                        id: dayid,  // Unique id combining slot and index
                        start: parsedSlot?.start,
                        end: parsedSlot?.end,
                        location: parsedSlot?.location || "",
                        lesson_type: parsedSlot?.lesson_type || "",
                    }));
                }).flat();  // Use .flat() to flatten the array of arrays
                // Check if slot_data has any slots and then set the state
                if (slot_data.length) {
                    setSlots(slot_data);
                }
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading2(false)
            })
    }

    function getLessonTypes() {
        axiosInstance.get(`getinstructor/${credentials?.id}`, {
            headers: {
                Authorization: `Bearer ${credentials.token}`
            }
        })
            .then(res => {
                const types = res.data.instructor?.lesson_type
                    ? res.data.instructor.lesson_type.split(',').map(s => s.trim()).filter(Boolean)
                    : []
                setLessonTypes(types)
            })
            .catch(err => console.log(err))
    }

    function getDayName(dayId) {
        switch (dayId) {
            case 1: return 'Monday'
            case 2: return 'Tuesday'
            case 3: return 'Wednesday'
            case 4: return 'Thursday'
            case 5: return 'Friday'
            case 6: return 'Saturday'
            case 7: return 'Sunday'
        }
    }

    // ============================================

    // adding slot
    function onAddSlot(setSlots) {
        setSlots(ref => [...ref, { id: dayid, start: "", end: "", location: "", lesson_type: "" }])
    }

    // update location or lesson_type for a slot
    function handleSlotFieldChange(index, keyname, value) {
        setSlots(datas => {
            let updatedSlots = [...datas];
            updatedSlots[index][keyname] = value;
            return updatedSlots;
        });
    }

    // removing slot 
    function onRemoveSlot(id) {
        swal({
            title: "Are you sure?",
            text: "You want to remove this time slot",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(willdelete => {
            if (willdelete) {
                const temprows = [...slots]
                temprows.splice(id, 1);
                setSlots(temprows.map((ref, i) => ({ ...ref, id: dayid })))
                setIsDisabled(false)
            }
        })

    }

    // ============================================

    // collect slots data
    function handleChangeslotsData(index, keyname, value, setData) {
        // Check if the new start time already exists in the current slots
        if (slots.some((slot, idx) => idx !== index && slot.start === value)) {
            swal('Oops', `Time Slot (${moment(value, 'HH:mm').format('hh:mm A')}) is already added!`, 'warning');
            setData(datas => {
                let updatedSlots = [...datas];
                updatedSlots[index][keyname] = '';
                updatedSlots[index]['end'] = '';
                return updatedSlots;
            });
            return;
        }

        const startTime = value;
        const endTime = calculateTimeAfter60Minutes(value);

        if (validateSlot({ start: startTime, end: endTime }, index)) {
            const getElement = document.getElementById(`start_time${index}`)
            getElement.blur()
            swal('Oops', `Time Slot ( ${moment(startTime, 'HH:mm').format('hh:mm A')} - ${moment(endTime, 'HH:mm').format('hh:mm A')} ) overlaps with existing slots!`, 'warning');
            setData(datas => {
                let oldSlots = [...datas];
                oldSlots[index][keyname] = '';
                oldSlots[index]['end'] = '';
                return oldSlots;
            });

            return;
        }

        setIsDisabled(false)
        // Continue updating the slots if no duplicates or overlaps found
        setData(datas => {
            let updatedSlots = [...datas];
            updatedSlots[index][keyname] = value;
            updatedSlots[index]['end'] = endTime;
            return updatedSlots;
        });
    }

    // validate if any overlaping 
    const validateSlot = (newSlot, index) => {

        const newstart = newSlot.start.replace(':', '')
        const newend = newSlot.end.replace(':', '')

        // console.log('new : ', newstart, newend)

        let isOverlape = slots.filter((item, ind) => ind != index).some((item) => {

            const existstart = item.start.replace(':', '')
            const existend = item.end.replace(':', '')

            return (
                (newstart > existstart && newstart < existend) ||
                (newend > existstart && newend < existend)
            )
        })
        return isOverlape;
    };

    // Calculate time for 2 Hours Slot
    const calculateTimeAfter60Minutes = (time) => {
        if (!time) return '';

        const [hours, minutes] = time.split(':');
        let newHours = parseInt(hours, 10);
        let newMinutes = parseInt(minutes, 10);

        // Add 120 minutes
        newMinutes += 120;

        // Handle overflow into hours
        if (newMinutes >= 60) {
            newHours += Math.floor(newMinutes / 60);
            newMinutes %= 60;
        }

        // Handle overflow into days
        newHours %= 24;

        // Return formatted time
        return `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`;
    };

    // ============================================

    // save all slots to main server
    const handleSaveSlots = async (e) => {
        e.preventDefault()
        try {
            setLoading(true)
            setLoading2(true);
            const formData = new FormData()
            formData.append('user_id', credentials?.id)
            formData.append('day', slot_id)
            formData.append("slots", JSON.stringify(slots))

            const response = await axiosInstance.post(`/add-slots`, formData, {
                headers: {
                    Authorization: `Bearer ${credentials.token}`
                }
            })

            if (response.data.success == true && response.data.message === 'Slots Added/Updated Successfully') {
                toast.success('Slots Saved Successfully !');
                setTimeout(() => navigate(`${config.appUrl}availability`), 2000)
            }

            // console.log(response.data)
            setLoading(false)
            setLoading2(false);
        } catch (error) {
            console.log(error)
            setLoading(false)
            setLoading2(false);
        }
    }

    // ============================================

    const debounceAddTime = (changeSlotData, delay) => {
        // let slotTimer = null;
        return function (index, keyname, value, setData) {
            const endTime = calculateTimeAfter60Minutes(value);
            setData(datas => {
                let updatedSlots = [...datas];
                updatedSlots[index][keyname] = value;
                updatedSlots[index]['end'] = endTime;
                return updatedSlots;
            });

            if (slotTimerRef.current) {
                clearTimeout(slotTimerRef.current)
            }

            slotTimerRef.current = setTimeout(() => {
                changeSlotData(index, keyname, value, setData);
            }, delay)
        }
    }

    // better function for adding slots
    const slotDebounce = debounceAddTime(handleChangeslotsData, 2000)

    return (
        <>
            {
                loading2 && <Loader />
            }

            <ContainerDashboard title="Add / Edit Slots" description="Everything here">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-md-12">
                            <div className="p-4 py-5 bg-gradientt rounded-4" style={{ minHeight: '75vh' }}>
                                <div className='row'>
                                    <div className="col-12">

                                        <div className="d-md-flex justify-content-between mb-4 align-items-center">
                                            <h4 className='text-green mb-0 fs-2 text-center'> {dayName}</h4>
                                            <div className='text-center mt-md-0  mt-5'>
                                                <button
                                                    onClick={() => onAddSlot(setSlots)}
                                                    className="button btn-green "
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <i className='icon-plus me-2'></i> Add New Slot
                                                </button>
                                                <button type="button" onClick={() => navigate(-1)} className="button btn-black text-white ms-3">
                                                    <i className='icon-arrow-left me-3 fs-5'></i>
                                                    back</button>
                                            </div>
                                        </div>
                                        <form onSubmit={handleSaveSlots}>
                                            <div className="row my-5">
                                                {slots?.map((ref, index) => {
                                                    return (
                                                        <div className="col-12 mb-4">
                                                            <div key={ref.id} className={`row mx-0 p-4 bg-white align-items-end rounded-5`}>
                                                                <div className="col-md-4 my-2">
                                                                    <label className="label-text mb-2"> Location </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control fs-5"
                                                                        value={ref.location}
                                                                        style={{ height: '40px' }}
                                                                        required
                                                                        placeholder="Enter location"
                                                                        onChange={e => handleSlotFieldChange(index, "location", e.target.value)}
                                                                    />
                                                                </div>

                                                                <div className="col-md-3 my-2">
                                                                    <label className="label-text mb-2"> Driving Lesson Type </label>
                                                                    <select
                                                                        className="form-select fs-5"
                                                                        value={ref.lesson_type}
                                                                        style={{ height: '40px' }}
                                                                        required
                                                                        onChange={e => handleSlotFieldChange(index, "lesson_type", e.target.value)}
                                                                    >
                                                                        <option value="">Select Lesson Type</option>
                                                                        {lessonTypes?.map((type, idx) => (
                                                                            <option key={idx} value={typeof type === 'string' ? type : type?.name}>
                                                                                {typeof type === 'string' ? type : type?.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-2 my-2">
                                                                    <label className="label-text mb-2"> Start time </label>
                                                                    <input
                                                                        type="time"
                                                                        className="form-control fs-5"
                                                                        name="start"
                                                                        value={ref.start}
                                                                        style={{ height: '40px' }}
                                                                        id={`start_time${index}`}
                                                                        required
                                                                        onChange={e => {
                                                                            if (!isDisabled)
                                                                                setIsDisabled(true)
                                                                            slotDebounce(index, "start", e.target.value, setSlots)
                                                                            // handleChangeslotsData(index, "start", e.target.value, setSlots)
                                                                        }}
                                                                    />
                                                                </div>

                                                                <div className="col-md-2 my-2">
                                                                    <label className="label-text mb-2"> End time </label>
                                                                    <input
                                                                        type="time"
                                                                        className="form-control fs-5"
                                                                        value={ref.end}
                                                                        style={{ height: '40px' }}
                                                                        // required
                                                                        // onChange={e => handleChangeslotsData(index, "end", e.target.value, setSlots)}
                                                                        readOnly
                                                                    />
                                                                </div>

                                                                <div className="col-md-1 text-center my-2">
                                                                    {
                                                                    
                                                                        <button
                                                                            type='button'
                                                                            className="btn-danger rounded-circle py-2 border-0 text-white fs-3 px-3 bg-danger"
                                                                            onClick={() => onRemoveSlot(index)}
                                                                        >
                                                                            {" "}
                                                                            <i className='icon-trash2'></i>
                                                                        </button>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>


                                            <div className='text-center'>
                                                <button type="submit" className="button btn-green color-white" disabled={isDisabled}>
                                                    <i className={`bi bi-${loading ? 'arrow-repeat rotation me-3' : 'save'} me-2`}> </i>
                                                    Save </button>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </ContainerDashboard>
        </>
    )
}

export default AddSlots